<script setup lang="ts">
import { provide, ref, type Ref } from 'vue'
//import { useLocalStorage } from '@vueuse/core'
import type { Room } from '@/models/Room'
import type { Container } from '@/models/Container'
import type { ContainerAction } from '@/actions/ContainerMove'

const room: Ref<Room | null> = ref(null)
//const room = useLocalStorage<Room>('move_container_room')
const container: Ref<Container | null> = ref(null)
const action: Ref<ContainerAction | null> = ref(null)

provide('room', room)
provide('container', container)
provide('action', action)
</script>

<template>
  <RouterView />
</template>
